import * as api from '../util/apis';
import { ENV } from '../constants/Constants';

import { Campaign, SlotResults } from '@horasys/bellplus/common/types';
import {
	getCampaignFromJson,
	getJsonFromCampaign,
	getSlotResultsFromJson,
} from '../jsonutils/campaign';
import { getLocationFromJson } from '../jsonutils/location';
import { MainLocationAllocation } from '@horasys/bellplus/common/types';

export const getAllCampaigns = async (
	pageIndex = 0,
	pageSize = 10,
	filterRequestObject: any = [],
	sortRequestObject: any = [],
): Promise<any> => {
	try {
		const filterArray = filterRequestObject.filter((filter: any) => {
			if (filter.value.length > 0) {
				return true;
			}
			return false;
		});

		const requestObject = {
			pageIndex: pageIndex,
			pageSize: pageSize,
			sort: sortRequestObject,
			filters: filterArray,
		};
		const resp: any = await api.postapiresponses(
			ENV.dev.campaign + '/list',
			requestObject,
		);
		const campaignObj: any = {};
		campaignObj.totalElements = resp.data.data.totalElements;
		const campaignList = resp.data.data.list;
		campaignObj.list = campaignList;
		return Promise.resolve(campaignObj);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCampaignDetails = async (campaignId: number): Promise<Campaign> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.campaign + '/' + campaignId);
		console.log('Campaign which is getting fetched', resp.data);
		const campaign: Campaign = await getCampaignFromJson(resp.data.data);
		// console.log('Campaign which is getting fetched', campaign);
		return Promise.resolve(campaign);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCampaignPaymentDetails = async (campaignId: number): Promise<any> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.campaign + '/' + campaignId);
		// let campaign: Campaign = await getCampaignFromJson(resp.data.data);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const submitCampaignDetails = async (campaign: Campaign): Promise<string> => {
	try {
		const json: any = getJsonFromCampaign(campaign);
		const resp: any = await api.postapiresponses(ENV.dev.campaign, json);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const checkCampaignName = async (enteredName: string): Promise<any> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.campaign + '/searchByName/' + enteredName,
		);
		if (resp.data.data.length > 0) {
			return Promise.reject({ campaignName: 'Campaign Already Exists' });
		}
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const campaignNameSearch = async (enteredName: string): Promise<any> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.campaign + '/searchByName/' + enteredName,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCities = async (): Promise<Array<string>> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.location + '/cities');
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAreas = async (city: string): Promise<Array<string>> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.location + '/areas/?cities=' + city,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAllLocationDetails = async (
	requestObject: any,
): Promise<Array<MainLocationAllocation>> => {
	try {
		const resp: any = await api.postapiresponses(
			ENV.dev.location + '/search',
			requestObject,
		);
		const locations: Array<MainLocationAllocation> = [];
		resp.data.data.forEach((location: any) => {
			const ml: MainLocationAllocation = getLocationFromJson(location);
			locations.push(ml);
		});

		return Promise.resolve(locations);
	} catch (error) {
		return Promise.reject(error);
	}
};
export const getLocationGroupSearchResults = async (
	requestObject: any,
): Promise<Array<any>> => {
	try {
		const resp: any = await api.postapiresponses(
			ENV.dev.campaignLocationGroupSearch,
			requestObject,
		);
		let locationsGroupsResults: Array<any> = [];
		locationsGroupsResults = resp.data.data;
		return Promise.resolve(locationsGroupsResults);
	} catch (error) {
		return Promise.reject(error);
	}
};
export const getAutoSlotAllocation = async (requestObject: any): Promise<SlotResults> => {
	try {
		const resp: any = await api.postapiresponses(
			ENV.dev.advertisement + '/slot-calculator/main-location/automatic',
			requestObject,
		);
		const slotResults: SlotResults = getSlotResultsFromJson(resp.data.data);
		return Promise.resolve(slotResults);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getManualSlotAllocation = async (
	requestObject: any,
): Promise<SlotResults> => {
	try {
		const resp: any = await api.postapiresponses(
			ENV.dev.advertisement + '/slot-calculator/main-location/manual',
			requestObject,
		);
		const slotResults: SlotResults = getSlotResultsFromJson(resp.data.data);
		return Promise.resolve(slotResults);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteSlotAllocation = async (uuid: any): Promise<any> => {
	try {
		const resp = await api.postapiresponses(
			ENV.dev.advertisement + '/slot-calculator/delete/' + uuid,
			null,
		);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateCampaignDetails = async (campaign: Campaign): Promise<any> => {
	const json = getJsonFromCampaign(campaign);
	try {
		await api.putapiresponses(ENV.dev.campaign + '/' + campaign.id, json);
		Promise.resolve();
	} catch (error) {
		Promise.reject(error);
	}
};

export const getAllCampaignsBasedOnClient = async (
	clientId: number,
): Promise<Array<Campaign>> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.campaign + '?clientId=' + clientId,
		);
		const campaignList = resp.data.data;
		const campaigns: Array<Campaign> = [];
		campaignList.forEach((campaignJson: any) => {
			campaigns.push(getCampaignFromJson(campaignJson));
		});
		return Promise.resolve(campaigns);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateCampaignAdvertismentStatus = async (
	campaignId: any,
	requestData: any,
) => {
	const resp = await api.putapiresponses(
		ENV.dev.campaign + '/' + campaignId + '/advertisement-status',
		requestData,
	);
	return resp;
};

export const updateCampaignPaymentStatus = async (campaignId: any, requestData: any) => {
	const resp = await api.putapiresponses(
		ENV.dev.campaign + '/' + campaignId + '/payment-status',
		requestData,
	);
	return resp;
};
export const getLocationGroupManualSlotAllocation = async (
	requestObject: any,
): Promise<any> => {
	try {
		const resp: any = await api.postapiresponses(
			ENV.dev.advertisement + '/slot-calculator/location-group/manual',
			requestObject,
		);
		const slotResults: any = getSlotResultsFromJson(resp.data.data);
		return Promise.resolve(slotResults);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCampaign = async (campaignId: number) => {
	try {
		await api.deleteapiresponses(ENV.dev.campaign + '/' + campaignId);
		return Promise.resolve();
	} catch (error) {
		return Promise.reject(error);
	}
};


export const getRecentCampaigns = (): any => {
	return async () => {
		try {
			const requestObject = {
				pageIndex: 0,
				pageSize: 10,
				sort: [],
				filters: []
				// filters: [{ columnName: 'companyName', operationType: 'MATCH', value: clientName }],
			};

			const resp: any = await api.postapiresponses(ENV.dev.campaign + '/list',
				requestObject)
			return Promise.resolve(resp.data.data.list);
		} catch (error) {
			return Promise.reject(error);
		}
	}
};
export const getRecentCampaign = async () => {
	// return async () => {
		try {
			const requestObject = {
				pageIndex: 0,
				pageSize: 10,
				sort: [],
				filters: []
				// filters: [{ columnName: 'companyName', operationType: 'MATCH', value: clientName }],
			};

			const resp: any = await api.postapiresponses(ENV.dev.campaign + '/list',
				requestObject)
			return Promise.resolve(resp.data.data.list);
		} catch (error) {
			return Promise.reject(error);
		}
	// }
};
